const rules = {
  authEmail: {
    required: true,
    email: true, // disable the default
    // Email regex pattern
    /* eslint-disable-next-line no-useless-escape */
    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },

  fname: {
    required: true,
  },

  lname: {
    required: true,
  },

  serialnum: {
    required: true,
    pattern: /^\d{3}-\d{8}$/,
  },

  contractnum: {
    required: true,
    pattern: /^\d{11,12}$|^\d{3}-\d{8}$|^\d{1}[-]\d{10}$/,
  },

  productkey: {
    required: true,
  },

  requestCode: {
    required: true,
    pattern: /^[A-Z0-9]{4} [A-Z0-9]{4} [A-Z0-9]{4} [A-Z0-9]{4} [A-Z0-9]{4} [A-Z0-9]{4} [A-Z0-9]{4} [A-Z0-9]{4}$/,
  },

  overActivation: {
    required: true,
  },

  authorizationRequest: {
    required: true,
  },

  comments: {
    required: true,
  },
};

export default rules;
